function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
var buildStyle = function(_, param) {
    var start = param.start, end = param.end;
    var _obj;
    return {
        base: (_obj = {
            height: 18
        }, _defineProperty(_obj, start.padding, 24), _defineProperty(_obj, end.padding, 24), _defineProperty(_obj, "display", 'flex'), _defineProperty(_obj, "alignItems", 'center'), _defineProperty(_obj, "a", {
            textDecoration: 'none'
        }), _obj),
        image: {
            width: 93,
            height: 18,
            objectFit: 'contain'
        }
    };
};
export var useStyle = function(isRtl) {
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (!builtStyle) {
        return {
            logoWrapperStyles: {},
            logoImageStyles: {}
        };
    }
    var base = builtStyle.base, image = builtStyle.image;
    return {
        logoWrapperStyles: base,
        logoImageStyles: image
    };
};
